import 'zone.js/plugins/zone-error';
import {EnvironmentAdmin} from 'compob2b-libs';

/**
 * Конфигурация тестового сервера, он же Staging
 */
class EnvironmentAdminTest extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  serverPicturesPath = 'https://zubrdata-java.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://zubrdata-java.compo-soft.ru/documents';
  serverApi =  'https://zubrdata-java.compo-soft.ru/api/v1';
  serverUrl =  'https://zubrdata-java.compo-soft.ru';
  impersonatePortalPath = 'https://zubr-java.compo-soft.ru/cabinet/dashboard';
  impersonate = true;
  accessRolesCatalog = true;
  enableWorkflowButton = true;
  showDiscountPanel = true;
  featureGroupPermissions = true;
}

export const environment = new EnvironmentAdminTest();
